import { FC } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { RootState } from "../../store";

interface PropType {
  component: React.FC;
}

const ProtectedSnapshotRoute: FC<PropType> = ({ component: Component }) => {
  const currentSnapshotId = useSelector(
    (state: RootState) => state.snapshotModel.currentSnapshotId
  );

  if (currentSnapshotId) return <Component />;
  return <Navigate to="/token-submit" />;
};

export default ProtectedSnapshotRoute;
